import React from "react";
import "./DilatationMeter.scss";
import className from "../../../shared/className";

export default function DilatationMeter({ dilatation }) {
  const [devicePixelRatio, setDevicePixelRatio] = React.useState(
    window.devicePixelRatio,
  );
  React.useEffect(() => {
    function handleResize() {
      setDevicePixelRatio(window.devicePixelRatio);
    }
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  });

  if (isNaN(Number(dilatation))) return <div />;

  return (
    <div className="dilatation-meter">
      {[...Array(10).keys()].map((num) => (
        <div
          key={num}
          {...className({ filled: num + 1 <= +dilatation })}
          style={{ margin: 0, marginBottom: 2 / devicePixelRatio }}
        ></div>
      ))}
    </div>
  );
}
